/* Version F: keep long Judge.me review feeds compact on mobile while preserving every review. */
(() => {
  'use strict';
  if (!document.body.classList.contains('phf-page-product')) return;

  const MOBILE_LIMIT = 3;
  let queued = false;

  const apply = widget => {
    const reviewsContainer = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!reviewsContainer) return;

    const reviews = Array.from(reviewsContainer.querySelectorAll('.jdgm-rev'));
    let control = widget.querySelector('[data-phf-review-more]');

    if (reviews.length <= MOBILE_LIMIT) {
      reviews.forEach(review => review.classList.remove('phf-review-mobile-hidden'));
      if (control) control.remove();
      return;
    }

    const expanded = widget.dataset.phfReviewsExpanded === 'true';
    reviews.forEach((review, index) => review.classList.toggle('phf-review-mobile-hidden', !expanded && index >= MOBILE_LIMIT));

    if (!control) {
      control = document.createElement('button');
      control.type = 'button';
      control.className = 'phf-review-more';
      control.dataset.phfReviewMore = 'true';
      reviewsContainer.insertAdjacentElement('afterend', control);
      control.addEventListener('click', () => {
        widget.dataset.phfReviewsExpanded = widget.dataset.phfReviewsExpanded === 'true' ? 'false' : 'true';
        apply(widget);
      });
    }

    control.textContent = expanded ? 'Show fewer reviews' : 'Read more reviews';
    control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const run = () => {
    queued = false;
    document.querySelectorAll('.jdgm-rev-widg').forEach(apply);
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  };

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  schedule();
  setTimeout(schedule, 500);
  setTimeout(schedule, 1500);
})();
